import axios from 'axios';
import UserInfo from "./login_info";

export default axios.create({
  baseURL: `http://34.72.158.31:8080/`,
  headers: { 
        'Authorization': 'Bearer '+new UserInfo().TOKEN, 
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*'
      },
});